<template>
  <div class="centerPage">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
      <el-breadcrumb-item><a href="javascript:;" @click="$router.back()"
                             class="aHref">历史分析</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item>测试详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="formUserInfo">
      <div class="cnHomeTabsItem flex">
        <div class="avatar img" :style="'backgroundImage: url('+details.exam.exhibitImg+')'"></div>
        <div class="rightHome">
          <div class="flex">
            <span class="com"><strong>{{ details.exam.title }}</strong></span>
            <span class="number">测试单号：{{ no }}</span>
          </div>
          <div class="flex">
            <span class="com">测试费用：<span class="cost">￥{{ details.expense }}</span></span>
          </div>
          <div class="flex " :class="(details.examStatus==1||details.examStatus==2)?'cost':'green'">
            {{ details.examStatus | statusFmt }}
          </div>
        </div>
      </div>
      <div class="cnHomeTabsItem ">
        <p class="infoTit">系统测试分析结果</p>
        <div class="appointInfo">
          <div class="result">
            <p class="artHead">
              <strong>测试得分：{{ data.result.score }}分</strong>
              <strong>测试结果：{{ data.analysis.title }}</strong>
            </p>
            <p class="suggest">
              {{ data.analysis.scoreRangeMin }}~{{ data.analysis.scoreRangeMax }}分：{{ data.analysis.analysisDesc }}
            </p>
            <p class="judge"> {{ data.exam.briefDesc }}</p>
          </div>
        </div>
      </div>
      <div class="cnHomeTabsItem ">
        <p class="infoTit">答题详情</p>
        <div v-for="resultOption in data.resultOptionList" :key="resultOption.examSubject.index"
             class="radioGroup">
          <p>{{ resultOption.examSubject.title }}</p>
          <!--单选-->
          <template v-if="resultOption.examSubject.subjectType===1">
            <el-radio-group v-model="answer[resultOption.examSubject.index-1]">
              <el-radio disabled :label="subjectOption.id"
                        v-for="subjectOption in resultOption.examSubject.examSubjectOptions"
                        :key="subjectOption.id">
                {{ subjectOption.title }}
              </el-radio>
            </el-radio-group>
          </template>
          <!--判断-->
          <template v-else-if="resultOption.examSubject.subjectType===2">
            <el-radio-group v-model="answer[resultOption.examSubject.index-1]">
              <el-radio disabled :label="subjectOption.id"
                        v-for="subjectOption in resultOption.examSubject.examSubjectOptions"
                        :key="subjectOption.id">
                {{ subjectOption.title }}
              </el-radio>
            </el-radio-group>
          </template>
          <!--多选-->
          <template v-else-if="resultOption.examSubject.subjectType===3">
            <el-checkbox-group v-model="answer[resultOption.examSubject.index-1]">
              <el-checkbox
                  disabled
                  v-for="subjectOption in resultOption.examSubject.examSubjectOptions"
                  :key="subjectOption.id"
                  :label="subjectOption.id">
                {{ subjectOption.title }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <!--填空-->
          <template v-else-if="resultOption.examSubject.subjectType===4">
            <p class="answerContent">{{ answer[resultOption.examSubject.index - 1] }}</p>
          </template>
          <!--问答-->
          <template v-else>
            <p class="answerContent">{{ answer[resultOption.examSubject.index - 1] }}</p>
          </template>
        </div>
      </div>
      <div class="cnHomeTabsItem " v-if="details.examStatus===1">
        <p class="infoTit">待分析</p>
      </div>
      <div class="cnHomeTabsItem" v-else-if="details.examStatus===2||details.examStatus===3">
        <p class="infoTit">测试结果</p>
        <div class="appointInfo resultArea">{{ data.result.result }}</div>
      </div>
      <div class="cnHomeTabsItem" v-if="details.examStatus===3">
        <p class="infoTit">评价</p>
        <div class="appointInfo resultArea">{{ data.result.evaluate }}</div>
      </div>
      <div class="cnHomeTabsItem">
        <p class="infoTit">操作</p>
        <el-button @click="toUser()" size="small" class="btnGroup">用户信息</el-button>
        <el-button @click="toDoctor" size="small" v-if="data.result.resultEditor">医生信息</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "examHistoryDetail",
  data() {
    return {
      no: this.$route.query.no,
      details: {exam: {}},

      loading: false,
      evaluate: '',

      syncAssess: {
        isSync: false,
        isAnonymous: false,
      },

      data: {
        analysis: {},
        exam: {},
        result: {
          score: '',
        },
        resultOptionList: {},
      },

      answer: [],
      result: '',
    }
  },
  mounted() {
    if (this.no) {
      this.getData();

    } else {
      // this.$router.back();
    }
  },
  methods: {
    getData() {
      let that = this;
      this.$ajax
          .get(base.manager_api.exam.historyDetail.replace("{resultNo}", this.no))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.data = res.data.data;
              $(res.data.data.resultOptionList).each((index, obj) => {
                switch (obj.examSubject.subjectType) {
                  case 1:
                    that.answer[index] = parseInt(obj.answers);
                    break;
                  case 2:
                    that.answer[index] = parseInt(obj.answers);
                    break;
                  case 3:
                    that.answer[index] = obj.answers.split(',').map(Number);
                    break;
                  case 4:
                    that.answer[index] = obj.answers;
                    break;
                  case 5:
                    that.answer[index] = obj.answers;
                }
              })
              if (res.data.data.result.resultEditor) {
                that.getOtherData();
              }
            } else {
              // that.$router.back();
            }
          })
    },
    getOtherData() {
      this.$ajax.get(base.api.exam.result.details.replace("{no}", this.no)).then((res) => {
        if (res.data.status === 'success') {
          this.details = res.data.data;
        }
      })
    },
    toDoctor() {
      this.$router.push({path: '../../doctor/detail/' + this.data.result.resultEditor})
    },
    toUser() {
      this.$router.push({path: '../../user/detail/' + this.data.result.userId})
    },
  },
  filters: {
    statusFmt(status) {
      switch (status) {
        case 0:
          return "待测试";
        case 1:
          return "待结果";
        case 2:
          return "待评价";
        case 3:
          return "已完成";
      }
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/personalCenter.scss";

.centerPage {
  display: block;
  width: auto;

  .avatar {
    width: 150px;
    height: 75px;
  }
.cnHomeTabsItem{
  padding: 20px;
  .el-button{
    margin-top: 20px;
    background: #557BFF;
    border-radius: 0;
    color: #ffffff;
    border: none;
  }
}
.cnHomeTabsItem .rightHome .flex {
    justify-content: inherit;

    span.com {
      width: 30%;
    }

    .number {
      text-align: right;
      width: 40%;
    }
  }

  .appointInfo p, .appointInfo p span {
    width: auto;
  }

  .infoTit {
    margin-bottom: 0;
  }
}

::v-deep .el-radio-group {
  .el-radio__input.is-checked.is-disabled + .el-radio__label, .el-radio {
    color: #557BFF;
  }

  .el-radio__input.is-disabled + span.el-radio__label {
    color: #2F3139;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: transparent;
    border-color: #557BFF;
  }

  .is-disabled.is-checked .el-radio__inner:after {
    background: #557BFF;
  }

  .el-radio__inner {
    width: 12px;
    height: 12px;
    border: 1px solid #2F3139;
    border-radius: 50%;
    background: transparent;

    &:after {
      width: 6px;
      height: 6px;
      background: #557BFF;
      border-radius: 50%;
    }
  }
}

::v-deep .el-checkbox-group {
  .el-checkbox__input.is-checked.is-disabled + .el-checkbox__label, .el-checkbox {
    color: #557BFF;
  }

  .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #2F3139;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after,
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    border-color: #557BFF;
  }

  .el-checkbox__input.is-disabled .el-checkbox__inner {
    border-color: #2F3139;
    background: #ffffff;
  }
}

.answerContent {
  color: #557BFF;
}

.radioGroup {
  margin-top: 10px;
  line-height: 2;
  font-size: 13px;
}

.resultTest {
  border: 1px solid #BBBBBB;
  margin-top: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  padding: 13px;

  .el-textarea {
    width: 90%;

    ::v-deep .el-textarea__inner {
      border: none;
      background: transparent;
      font-size: 13px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      padding: 0;
      resize: none;
    }
  }

  .el-button {
    width: 80px;
    height: 26px;
    background: #557BFF;
    border-radius: 1px;
    padding: 0;
    border: none;
    color: #ffffff;
  }
}

.resultArea {
  font-size: 13px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  color: #2F3139;
  line-height: 2;
  margin: 10px 0;
  text-indent: 2em;
}

</style>